// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { DecodedToken } from '@coa/app/auth/model/decoded-token';

export const loginRequested = createAction('[AUTH] Login Requested', props<{ username: string, password: string, code?: string }>());
export const firstStepFormRequested = createAction('[AUTH] Login Form Requested');
export const loginFirstStepSuccess = createAction('[AUTH] Login First Step Success');
export const loginFirstStepError = createAction('[AUTH] Login First Step Error', props<{ error: string }>());

export const loginSuccess = createAction('[AUTH] Login Success', props<{
  accessToken: string,
  refreshToken: string,
  businessClientIds: number[]
}>());
export const loginError = createAction('[AUTH] Login Error', props<{ error: string }>());
export const loggedOut = createAction('[AUTH] LoggedOut');

export const decodedTokenUpdated = createAction('[AUTH] Decoded token updated', props<{ decodedToken: DecodedToken }>());

export const userRestored = createAction('[AUTH] User Restored', props<{ accessToken: string, refreshToken: string }>());
export const tokenRefreshed = createAction('[AUTH] Token Refreshed', props<{ accessToken: string, refreshToken: string }>());

export const resetPasswordRequested = createAction('[AUTH] Reset Password Requested', props<{ username: string }>());
export const resetPasswordSuccess = createAction('[AUTH] Reset Password Success', props<{ username: string }>());
export const resetPasswordError = createAction('[AUTH] Reset Password Error', props<{ error: string }>());

export const changePasswordRequested = createAction('[AUTH] Change Password Requested', props<{
  username: string,
  currentPassword: string,
  newPassword: string
}>());
export const changePasswordSuccess = createAction('[AUTH] Change Password Success');
export const changePasswordError = createAction('[AUTH] Change Password Error', props<{ error: string }>());
